module.exports = __webpack_public_path__ + "img/purchase6.efd9a8cd.png";